// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"OO","reco":"PO","products":"QO"};